import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as s } from "react";
const r = ({
  title: l,
  titleId: o,
  ...c
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M453.453 506.995V648.99c0 60.501 1.109 98.88 3.307 115.179 2.176 16.299 8.064 28.672 17.621 37.141s28.437 12.715 56.661 12.715c50.133 0 87.744-12.864 112.832-38.571 25.088-25.685 37.589-64.256 37.589-115.669 0-52.651-14.165-91.435-42.539-116.352s-78.293-37.376-149.739-37.376c-11.285 0-23.189.32-35.733.939zm0-23.04c7.851.32 14.421.469 19.776.469 67.669 0 113.899-10.645 138.667-31.957 24.747-21.312 37.141-55.787 37.141-103.445 0-33.216-4.864-58.923-14.571-77.099-9.728-18.176-24.277-32.192-43.712-42.069-19.456-9.877-52.672-14.827-99.669-14.827-12.245 0-24.768.469-37.632 1.408zm115.178 8.939c72.427 5.333 126.165 23.36 161.28 54.059 35.093 30.72 52.651 69.12 52.651 115.179 0 40.128-11.925 74.688-35.733 103.68s-54.293 47.957-91.435 56.896c-37.141 8.939-86.891 13.397-149.291 13.397H255.991v-21.632h24.469c27.243 0 46.144-3.456 56.64-10.347s17.173-17.621 19.968-32.213c2.816-14.571 4.245-48.469 4.245-101.781V359.839c0-51.712-1.493-85.099-4.459-100.139-2.987-15.04-9.259-25.387-18.816-31.019-9.557-5.653-30.485-8.469-62.784-8.469h-12.203V198.58l104.853-2.816 119.403-3.755c174.272 0 261.397 50.133 261.397 150.443 0 41.365-14.955 74.603-44.885 99.669-29.952 25.067-74.987 42.005-135.189 50.773z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = s(r);
export {
  n as default
};
